<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card no-body>
                <b-card-body style="display:flex;align-items:center;">
                    Selamat datang di aplikasi Penjualan Sinar Mutiara!
                    <b-button variant="outline-primary" class="mr-2" style="margin-left:auto;" @click="onClickShowCatalog">
                        Tampilkan Katalog
                    </b-button>
                    <b-button v-if="isAllowedToUpdateCatalog" variant="primary" @click="prepareUpdate">
                        <!-- Update Katalog <b-badge variant="light">{{ counts.pending_public }}</b-badge> -->
                        Update Katalog
                    </b-button>
                </b-card-body>
            </b-card>
            <b-row>
                <b-col sm="12" lg="3">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5><i class="fa fa-fw fa-arrow-left mr-2" />Kirim Balik PGI</h5>
                        </div>
                        <hr class="my-2" />
                        <div class="brand-card-body" style="padding: 0">
                            <div>
                                <div class="text-value">{{ counts.send_back.pending }}</div>
                                <div class="text-uppercase text-muted small">PENDING</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.send_back.otw }}</div>
                                <div class="text-uppercase text-muted small">PERJALANAN</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm="12" lg="6">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5><i class="fa fa-fw fa-cubes mr-2" />Inventory</h5>
                        </div>
                        <hr class="my-2" />
                        <div class="brand-card-body" style="padding: 0">
                            <div>
                                <div class="text-value">{{ counts.inventory.pending }}</div>
                                <div class="text-uppercase text-muted small">PENDING APPROVAL</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.inventory.adj }}</div>
                                <div class="text-uppercase text-muted small">BUTUH ADJ. BARCODE</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.inventory.req_lost }}</div>
                                <div class="text-uppercase text-muted small">REQUEST HILANG</div>
                            </div>
                            <div>
                                <div class="text-value" style="color: red">{{ counts.inventory.retur_reset }}</div>
                                <div class="text-uppercase text-muted small">RETUR RESET</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm="12" lg="3">
                    <b-card>
                        <div class="d-flex justify-content-between">
                            <h5><i class="fa fa-fw fa-file mr-2" />Invoice</h5>
                        </div>
                        <hr class="my-2" />
                        <div class="brand-card-body" style="padding: 0">
                            <div>
                                <div class="text-value">{{ counts.invoice.draft }}</div>
                                <div class="text-uppercase text-muted small">DRAFT</div>
                            </div>
                            <div>
                                <div class="text-value">{{ counts.invoice.ongoing }}</div>
                                <div class="text-uppercase text-muted small">ONGOING</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <!-- <b-col lg="4" sm="6" xs="12">
                    <b-card no-body footer-class="px-3 py-2">
                        <b-card-body class="p-3 clearfix">
                            <i class="fa fa-truck bg-dark p-3 font-2xl mr-3 float-left"></i>
                            <div class="h5 mb-0 mt-2">2</div>
                            <div class="text-muted text-uppercase font-weight-bold font-xs">Request Kirim Balik PGI</div>
                            <div class="text-right mt-3">
                            <b-btn size="sm" variant="primary">Manage</b-btn>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col> -->
            </b-row>

            <b-card>
                <b-tabs v-if="isAllowedToStockDelivery" v-model="activeMainTab" nav-class="nav-tabs" content-class="mt-3">
                    <b-tab title="Barang Pending">
                        <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Barang Pending</h5>
                        <hr />
                        <b-row>
                            <b-col md="3">
                                <b-form-group label="No. Faktur PGI">
                                    <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="IMEI / SN">
                                    <b-form-input v-model="filter.imeiSn" maxlength="100" @keydown.enter="getItems" />
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Cabang">
                                    <b-form-input v-model="filter.branch" maxlength="5" @keydown.enter="getItems" />
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Aksi">
                                    <b-button variant="primary" @click="getItems()">
                                        <i class="fa fa-search mr-2" />Cari
                                    </b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-table bordered hover show-empty no-local-sorting
                            :busy="isBusy"
                            :items="items"
                            :fields="fields"
                            @sort-changed="onSortChanged"
                            responsive class="mb-3"
                        >
                            <template v-slot:empty>
                                Tidak ada data barang.
                            </template>
                            <template v-slot:cell(item)="row">
                                {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                                <div class="small text-muted">
                                    {{ row.item.kind }} - {{ row.item.brand }}
                                </div>
                            </template>
                        </b-table>
                        <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
                    </b-tab>
                    <b-tab title="Stok Kloter">
                        <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Stok Kloter</h5>
                        <hr />
                        <b-nav tabs class="mb-3">
                            <b-nav-item
                                v-for="(group, idx) in optItemGroup"
                                :key="group.id"
                                :active="activeBatchStockTab === idx"
                                @click="activeBatchStockTab = idx; onBatchStockTabChange(idx)"
                            >
                                {{ group.name }}
                            </b-nav-item>
                        </b-nav>
                        <b-row>
                            <b-col md="3">
                                <b-form-group label="Tahun">
                                    <b-form-select v-model="batchStockFilter.year" :options="optYear" value-field="id" text-field="name" />
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Source">
                                    <b-form-select v-model="batchStockFilter.source" :options="optSource" value-field="id" text-field="name" />
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Source">
                                    <b-form-select v-model="batchStockFilter.isBatangan" :options="optIsBatangan" value-field="id" text-field="name" />
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Aksi">
                                    <b-button variant="primary" @click="getBatchStock()">
                                        <i class="fa fa-search mr-2" />Cari
                                    </b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="my-2" v-if="!isBatchStockBusy">
                            <div class="">
                                Terakhir diperbarui: <span class="font-weight-bold">{{ batchStockLastUpdated != null ? batchStockLastUpdated : "-" }}</span>
                            </div>
                            <div>
                                Jenis: <span class="font-weight-bold">{{ 
                                batchStockFilter.itemGroup.item_kinds.map(item => item.name).join(', ') }}</span>
                            </div>
                        </div>
                        <b-table bordered hover show-empty no-local-sorting
                            :busy="isBatchStockBusy"
                            :items="batchStock"
                            :fields="batchStockFields"
                            responsive class="mb-3"
                        >
                            <template v-slot:empty>
                                Tidak ada data barang.
                            </template>
                            <template v-slot:cell(item)="row">
                                {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                                <div class="small text-muted">
                                    {{ row.item.kind }} - {{ row.item.brand }}
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                </b-tabs>
                <template v-else>
                    <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Barang Pending</h5>
                    <hr />
                    <b-row>
                        <b-col md="3">
                            <b-form-group label="No. Faktur PGI">
                                <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label="IMEI / SN">
                                <b-form-input v-model="filter.imeiSn" maxlength="100" @keydown.enter="getItems" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label="Cabang">
                                <b-form-input v-model="filter.branch" maxlength="5" @keydown.enter="getItems" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label="Aksi">
                                <b-button variant="primary" @click="getItems()">
                                    <i class="fa fa-search mr-2" />Cari
                                </b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-table bordered hover show-empty no-local-sorting
                        :busy="isBusy"
                        :items="items"
                        :fields="fields"
                        @sort-changed="onSortChanged"
                        responsive class="mb-3"
                    >
                        <template v-slot:empty>
                            Tidak ada data barang.
                        </template>
                        <template v-slot:cell(item)="row">
                            {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                            <div class="small text-muted">
                                {{ row.item.kind }} - {{ row.item.brand }}
                            </div>
                        </template>
                    </b-table>
                    <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
                </template>
            </b-card>

<!--             <tableau-viz id='tableau-viz' src='https://prod-apsoutheast-a.online.tableau.com/t/ekasatria/views/testworkbook/Sheet1' toolbar='bottom' v-if="roleId == 1" /> -->
        </div>

        <b-modal id="m-update" title="Update Katalog" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-alert show>
                Update Katalog Terakhir :
                <li v-for="(item, index) in catalogLogs" :key="'catalog-log-' + index" class="mb-2">
                    {{ $helper.parseDate(item.run_at) }} {{ $helper.parseHourMinute(item.run_at) }} <strong>({{ item.run_by.fullname }})</strong>
                    <div class="small text-muted" style="margin-left:20px">Office :
                        <span v-if="item.office_name == null">-</span>
                        <span v-else>{{ item.office_name }}</span>
                    </div>
                    <div class="small text-muted" style="margin-left:20px">Divisi :
                        <span v-if="item.division_name == null">-</span>
                        <span v-else>{{ item.division_name }}</span>
                    </div>
                    <div v-if="item.start_date != null && item.end_date != null" >
                        <div class="small text-muted" style="margin-left:20px">Periode Approve:
                            <span v-if="item.start_date == null && item.end_date == null">-</span>
                            <span v-else>{{ $helper.parseDate(item.start_date) }} - {{ $helper.parseDate(item.end_date)}}</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="small text-muted" style="margin-left:20px">Periode Approve <strong>Lengkap</strong> :
                            <span v-if="item.start_date_lengkap == null && item.end_date_lengkap == null">-</span>
                            <span v-else>{{ $helper.parseDate(item.start_date_lengkap) }} - {{ $helper.parseDate(item.end_date_lengkap)}}</span>
                        </div>
                        <div class="small text-muted" style="margin-left:20px">Periode Approve <strong>Batangan</strong> :
                            <span v-if="item.start_date_batangan == null && item.end_date_batangan == null">-</span>
                            <span v-else>{{ $helper.parseDate(item.start_date_batangan) }} - {{ $helper.parseDate(item.end_date_batangan)}}</span>
                        </div>
                    </div>
                </li>
            </b-alert>

            <hr />
            <div class="mt-4">
                <div>
                    <strong>Lokasi Office :</strong>
                    <b-form-select class="mt-1"
                        v-model="catalogOffice"
                        value-field="id"
                        text-field="name"
                        :options="optOffice"
                        @change="clearUpdateCatalog"
                    />
                </div>
                <div class="mt-3">
                    <strong>Divisi Barang :</strong>
                    <b-form-select class="mt-1"
                        v-model="catalogDivision"
                        value-field="id"
                        text-field="name"
                        :options="optDivision"
                        @change="clearUpdateCatalog"
                    />
                </div>
                <div class="mt-3">
                    <strong>Periode Approve Barang:</strong>
                    <b-row class="mt-1">
                        <b-col>
                            <b-form-group label="Dari">
                                <b-form-input type="date" v-model="startDate" @change="runCountCatalog" />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Sampai">
                                <b-form-input type="date" v-model="endDate" @change="runCountCatalog" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div v-if="(!$helper.isBlank(startDate) && !$helper.isBlank(endDate))">
                <div>Apakah anda yakin ingin melakukan update katalog ?</div>
                <p class="mb-0" v-if="!$helper.isBlank(startDate) && !$helper.isBlank(endDate)">Sebanyak <strong>{{ catalogCountLengkap }} barang baru </strong> akan ditampilkan untuk publik!</p>
            </div>
            <div class="mt-4 text-right">
                <b-button variant="outline-primary" class="mr-2" :disabled="isBusy" @click="$bvModal.hide('m-update')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isSubmitted || startDate == null || endDate == null" @click="confirmUpdate">
                    {{ isSubmitted ? "Mengupdate..." : "Update Katalog" }}
                </b-button>
            </div>
        </b-modal>
<!--         <tableau-viz id="tableauViz"
            src='https://prod-apsoutheast-a.online.tableau.com/t/ekasatria/views/AdminInsightsStarter/Overview'
            token='eyJraWQiOiI3ZDNkYTYyNi1kZGY5LTQ4N2QtODc4MS05NmE1MGE4ZTU3MzAiLCJpc3MiOiJlNTM5MGRjNC1kMzgxLTQ5MzktYTJmNi1kYWJmZDE4NzE0NGMiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJla2Euc20xQHNpbmFybXV0aWFyYWNlbGwuY29tIiwiYXVkIjoidGFibGVhdSIsInNjcCI6InRhYmxlYXU6dmlld3M6ZW1iZWQiLCJqdGkiOiJ5b3VyLTI1Ni1iaXQtc2VjcmV0IiwiZXhwIjoxNjc0MjAxMzc0NTkwfQ.EWAeXUlvQlHRMT6jxs0PUHsmR3Msq5Ow_GihCPPjBBA'>
        </tableau-viz> -->
    </div>
</template>

<script>
import EnumPermissions from '@/shared/enum-permissions'
export default {
    name: 'dashboard',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitted: false,
            counts: {
                send_back: {
                    pending: "...",
                    otw: "..."
                },
                invoice: {
                    draft: "...",
                    ongoing: "..."
                },
                inventory: {
                    pending: "...",
                    adj: "...",
                    req_lost: "..."
                }
            },

            filter: {
                noFaktur: "",
                imeiSn: "",
                branch: ""
            },

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            items: [],

            activeMainTab: 0,
            isBatchStockBusy: false,
            batchStockLastUpdated: null,
            batchStock: [],
            activeBatchStockTab: 0,
            batchStockFilter: {
                itemGroup: null,
                source: "PGI",
                year: 2026,
                isBatangan: -1
            },

            batchStockFields: [
                { key: "year", label: "Tahun", sortable: false },
                { key: "month", label: "Bulan", sortable: false },
                { key: "is_batangan", label: "Tipe", sortable: false },
                { key: "source", label: "Source", sortable: false },
                { key: "total_delivery", label: "Total Pengiriman", sortable: false },
                { key: "total_approved", label: "Total Disetujui", sortable: false },
                { key: "total_stock", label: "Total Stok", sortable: false },
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "no_faktur_pgi", label: "No. Faktur PGI", sortable: true },
                { key: "imei_sn", label: "IMEI / SN", sortable: true },
                { key: "branch", label: "Cabang", sortable: true },
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            catalogLogs: [],
            roleId: null,

            catalogDivision: null,
            catalogOffice: -1,

            startDate: null,
            endDate: null,
            catalogCountLengkap: 0,
            catalogCountBatangan: 0,

            optDivision: [],
            optOffice: [],
            optItemGroup: [],
            optSource: [
                { id: null, name: "Pilih source", disabled: true },
                { id: "PGI", name: "PGI" },
                { id: "SGP", name: "SGP" }
            ],
            optYear: [
                { id: null, name: "Pilih tahun", disabled: true },
                { id: 2025, name: "2025" },
                { id: 2026, name: "2026" },
                { id: 2027, name: "2027" },
                { id: 2028, name: "2028" },
                { id: 2029, name: "2029" },
                { id: 2030, name: "2030" }
            ],
            optIsBatangan: [
                { id: null, name: "Pilih tipe", disabled: true },
                { id: -1, name: "Semua" },  
                { id: false, name: "Lengkap" },
                { id: true, name: "Batangan" }
            ]
        }
    },
    methods: {

        init() {

            this.initStatus = 1

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                res.data.data = res.data.data.map(item => {
                    // Check if the item is the division HP
                    if (item.id === 1) {
                        return { ...item, name: "HP (Lengkap)" };
                    }
                    return item;
                });
                res.data.data.unshift({id: null, name: "Pilih Divisi", disabled: true})
                this.optDivision = res.data.data
            })

            let getOffices = this.$axios.get("master/offices").then(res => {
                res.data.data.unshift({id: -1, name: "Semua"})
                this.optOffice = res.data.data
            })

            let getCountDashboard = this.$axios.get("dashboard").then(res => {
                this.counts = res.data.data
            })

            let getCatalogLog = this.$axios.get("dashboard/catalog-log?count=5").then(res => {
                this.catalogLogs = res.data.data
            })

            if (this.isAllowedToStockDelivery) {
                this.getOptItemGroup().then(() => {
                    if (this.optItemGroup.length > 0) {
                        this.batchStockFilter.itemGroup = this.optItemGroup[0]
                        this.activeBatchStockTab = 0
                        this.getBatchStock()
                    }
                })
            }

            let getItems = this.getItems()

            Promise.all([getItems, getDivisions, getOffices, getCountDashboard, getCatalogLog]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                if(error.status == '401'){
                    return
                }
                this.initStatus = -1
                this.$helper.toastError(this, "Terjadi kesalahan pada sistem, mohon mencoba untuk refresh / logout dan login kembali, sebelum menghubungi team IT.")
            })
        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn
            }

            if(!this.$helper.isBlank(this.filter.branch)) {
                param += "&filterBranch=" + this.filter.branch
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("dashboard/pending"+ param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("dashboardFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        getBatchStock() {
            if (!this.batchStockFilter.itemGroup || !this.batchStockFilter.itemGroup.id) {
                return Promise.resolve()
            }

            this.isBatchStockBusy = true
            this.batchStock = []

            let param = `&item_group_id=${this.batchStockFilter.itemGroup.id}&source=${this.batchStockFilter.source}
            &year=${this.batchStockFilter.year}`

            if (typeof this.batchStockFilter.isBatangan === 'boolean') {
                param += `&is_batangan=${this.batchStockFilter.isBatangan ? "1" : "0"}`
            }

            return this.$axios.get("dashboard/stock-delivery?" + param).then(res => {
                const data = res.data.data || {}
                this.batchStock = data.items || []
                this.batchStockLastUpdated = data.last_updated_at || null
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBatchStockBusy = false
            })
        },

        getOptItemGroup() {
            this.isBatchStockBusy = true

            return this.$axios.get("master/item-groups").then(res => {
                this.optItemGroup = res.data.data || []
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBatchStockBusy = false
            })
        },

        onBatchStockTabChange(tabIndex) {
            const group = this.optItemGroup[tabIndex]
            if (group) {
                this.batchStockFilter.itemGroup = group
                this.getBatchStock()
            }
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        prepareUpdate() {

            this.$axios.get("dashboard/catalog-log?count=5").then(res => {
                this.catalogLogs = res.data.data
            })

            this.clearUpdateCatalog()

            this.$bvModal.show('m-update')
        },

        clearUpdateCatalog() {
            this.startDate = null
            this.endDate = null
            this.catalogCountBatangan = 0
            this.catalogCountLengkap = 0
        },

        confirmUpdate() {


            if (this.$helper.isBlank(this.catalogDivision)) {
                this.$helper.toastError(this, "Divisi harus diisi terlebih dahulu")
                return;
            }

            if(!this.$helper.isBlank(this.startDate) && this.$helper.isBlank(this.endDate)){
                this.$helper.toastError(this, "Tanggal approve barang harus diisi terlebih dahulu")
                return
            }

            if(this.$helper.isBlank(this.startDate) && !this.$helper.isBlank(this.endDate)){
                this.$helper.toastError(this, "Tanggal approve barang lengkap harus diisi terlebih dahulu")
                return
            }

            if(this.catalogCountBatangan <= 0 && this.catalogCountLengkap <= 0){
                this.$helper.toastError(this, "Tidak ada item baru yang berstatus READY atau RETUR untuk ditampilkan ke katalog!")
                return
            }

            let isConfirmed = confirm("Anda yakin ingin melakukan update katalog? Proses ini tidak dapat dibatalkan!")
            if(!isConfirmed) return

            this.isBusy = true
            this.isSubmitted = true
            let payload = {
                startDate: this.startDate,
                endDate: this.endDate,
                divisionId: this.catalogDivision,
                officeId: this.catalogOffice,
            }
            this.$axios.post("dashboard/catalog", payload).then(res => {

                this.$helper.toastSuccess(this, "Katalog publik berhasil diupdate!")
                this.$bvModal.hide("m-update")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                    this.clearUpdateCatalog();
                    this.catalogDivision = null
                    this.isBusy = false
                    this.isSubmitted = false
            })

        },

        runCountCatalog() {
            if(!this.$helper.isBlank(this.startDate) && !this.$helper.isBlank(this.endDate)){
                this.$axios.get("dashboard/catalog-count?startDate="+this.startDate+"&endDate="+this.endDate+"&divisionId="+this.catalogDivision+"&officeId="+this.catalogOffice).then(res => {
                    this.catalogCountLengkap = res.data.data
                })
                .catch(error => this.$helper.parseError(this, error))
            }

        },

        onClickShowCatalog() {
            window.open('https://katalog.sinarmutiaracell.com')
        }

    },
    computed: {
        isAllowedToUpdateCatalog() {
            return this.$helper.checkRoleNumber(EnumPermissions.UPDATE_CATALOG.toString(), localStorage.getItem("permissions"))
            || localStorage.getItem("roleName").includes("Superadmin")
        },
        isAllowedToStockDelivery() {
            return this.$helper.checkRoleNumber(EnumPermissions.STOCK_DELIVERY.toString(), localStorage.getItem("permissions"))
            || localStorage.getItem("roleName").includes("Superadmin")
        }
    },
    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listAdjustmentBarcodeFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("dashboardFilter"))
        }
        this.roleId = localStorage.getItem('roleId')
        this.init()
    }, mounted() {
        // document.getElementById("refresh").click()
    }
}
</script>
